import { capitalize } from 'lodash';

const convertPrefToTagFormat = (preference) => {
  const { name, category } = preference;

  if (category !== 'custom') {
    if (!['vegetarian', 'vegan'].includes(name)) {
      const tagName = name.split('_').join('');

      return capitalize(tagName);
    }

    return capitalize(name);
  }

  return capitalize(name);
};

export default convertPrefToTagFormat;
